export const BASE_URL = '/api';

export default BASE_URL;